﻿export class LexiboxImage {
    id: number;
    name: string;
    fileName: string;

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.fileName = json.fileName;
    }
}
